import React from 'react';
import '../../../Styles/Layout/Input-Area/CurrentResourceIndicator.css';
import { useResourceContext } from '../../../contexts/ResourceContext';
import { useAttachmentContext } from '../../../contexts/AttachmentContext';

export const CurrentResourceIndicator: React.FC = () => {
  const { expandedResource, isResourcesVisible } = useResourceContext();
  const { isTextAttachmentViewOpen } = useAttachmentContext();

  if (!expandedResource || !isResourcesVisible || isTextAttachmentViewOpen) return null;

  return (
    <div className="current-resource-indicator">
      <span className="current-resource-label">Viewing:</span>
      <span className="current-resource-text">
        {expandedResource.title || "Untitled Resource"}
      </span>
      <div className="spacer"></div>
    </div>
  );
};
